import cn from 'classnames/bind';
import React, { FunctionComponent } from 'react';

import { useI18n } from '@/shared/hooks/useI18n';

import {
    SpinnerSize,
    SpinnerAnimationType,
    SpinnerProps,
    SpinnerStrokeSize,
    SpinnerThemes,
} from './Spinner.types';
import { getClassNames } from './helpers';
import styles from './Spinner.module.css';

const cx = cn.bind(styles);

const Spinner: FunctionComponent<SpinnerProps> = (props) => {
    const {
        size = SpinnerSize.DEFAULT,
        strokeWidth = SpinnerStrokeSize.MEDIUM,
        animationType = SpinnerAnimationType.DEFAULT,
        theme = SpinnerThemes.DEFAULT,
        ...externalClassNames
    } = props;

    const getClassNamesParams = {
        cx,
        size,
        strokeWidth,
        animationType,
        externalClassNames,
        theme,
    };

    const { rootClassNames, spinnerClassNames, circleClassNames } =
        getClassNames(getClassNamesParams);

    const i18n = useI18n();

    return (
        <div className={rootClassNames}>
            <svg
                className={spinnerClassNames}
                viewBox="0 0 50 50"
                aria-label={i18n('spinner__loading')}
            >
                <circle cx="25" cy="25" r="20" fill="none" className={circleClassNames} />
            </svg>
        </div>
    );
};

export default Spinner;
